// LEGACY. `track()` acá quedó como no-op — los eventos del modelo
// viejo (storefront transaccional, landing privada, experimento home
// minimal, PWA prompt/share/recall) ya no se registran en
// `AnalyticsEvent`. Los que del modelo actual siguen vivos usan
// `src/lib/directory-tracking.ts` (whatsapp/call/link/search/hub_empty/
// web_vitals/js_error/not_found).
//
// El export se mantiene para que los components de storefront viejo y
// landing sigan compilando sin cambios. Cuando se decida borrar esos
// componentes completo, este archivo se puede eliminar.
//
// Ver docs/tracking-plan.md.

type TrackPayload = Record<string, unknown>;

export function track(_eventType: string, _payload?: TrackPayload): void {
  // no-op — reemplazado por directory-tracking.ts
}
